import React from "react";
import { Layout, Card, Typography, Form, Input, Button, Space, Select, message } from "antd";
import { useNavigate } from "react-router-dom";
import { SaveOutlined } from "@ant-design/icons";

import AppHeader from "../../components/Header";
import AppFooter from "../../components/Footer";
import "./index.css";

const { Content } = Layout;
const { Title, Text } = Typography;

export default function WritePost({ onAddPost, posts, loggedInUser, onLogout }) {
  const nav = useNavigate();
  const [form] = Form.useForm();
  const [msg, ctxHolder] = message.useMessage();

  const tagOptions = Array.from(new Set((posts || []).flatMap((p) => p.tags || []))).map((t) => ({
    label: t,
    value: t,
  }));

  const handleFinish = (values) => {
    const newPost = {
      id: Date.now().toString(),
      title: values.title,
      summary: values.summary,
      content: values.content,
      tags: values.tags || [],
      date: values.date,
    };
    onAddPost(newPost);
    msg.success("发布成功");
    nav(`/post/${newPost.id}`);
  };

  return (
    <Layout className="dmc dmc-layout page-shell write-layout">
      {ctxHolder}
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />

      <Content className="page-content write-content">
        <div className="write-container">
          <Title level={3} style={{ marginBottom: 8 }}>写文章</Title>
          <Text type="secondary">发布一篇新的内容</Text>

          <Card className="write-card">
            <Form
              form={form}
              layout="vertical"
              onFinish={handleFinish}
              initialValues={{ date: new Date().toISOString().slice(0, 10) }}
            >
              <Form.Item label="标题" name="title" rules={[{ required: true, message: "请输入标题" }]}>
                <Input placeholder="标题" />
              </Form.Item>

              <Form.Item label="摘要" name="summary" rules={[{ required: true, message: "请输入摘要" }]}>
                <Input placeholder="一句话概括" />
              </Form.Item>

              <Form.Item label="标签（可自定义）" name="tags">
                <Select mode="tags" allowClear placeholder="输入后回车创建标签" options={tagOptions} />
              </Form.Item>

              <Form.Item label="发布日期" name="date" rules={[{ required: true, message: "请输入日期" }]}>
                <Input placeholder="YYYY-MM-DD" />
              </Form.Item>

              <Form.Item label="正文" name="content" rules={[{ required: true, message: "请输入正文" }]}>
                <Input.TextArea rows={12} placeholder="正文内容..." />
              </Form.Item>

              <Space wrap>
                <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>发布</Button>
                <Button onClick={() => nav(-1)}>取消</Button>
              </Space>
            </Form>
          </Card>
        </div>
      </Content>

      <AppFooter />
    </Layout>
  );
}
